<template>
  <div class="w-full pt-8 pb-7 px-14 box-border overflow-x-auto">
    <el-steps class="horizontal-steps pt_tabs" :active="active" simple>
      <el-step
        title="维度设置"
        :class="['pt_tabs_basis', current == 1 ? 'pt_current' : '']"
        @click.native="switchStep($event, 1)"
      >
        <span slot="icon">1</span>
      </el-step>
      <el-step
        title="题目绑定"
        :class="['pt_tabs_basis', current == 2 ? 'pt_current' : '']"
        @click.native="switchStep($event, 2)"
      >
        <span slot="icon">2</span>
      </el-step>
      <el-step
        title="标准分/权重设置"
        :class="['pt_tabs_basis_big', current == 3 ? 'pt_current' : '']"
        @click.native="switchStep($event, 3)"
      >
        <span slot="icon">3</span>
      </el-step>
      <el-step
        title="测评报告设置"
        :class="current == 4 ? 'pt_current' : ''"
        @click.native="switchStep($event, 4)"
      >
        <span slot="icon">4</span>
      </el-step>
    </el-steps>
  </div>
</template>

<script>
export default {
  name: 'ProcessTab',
  props: {
    active: {
      type: [Number, null],
      default: null
    },
    current: {
      type: [Number, null],
      default: null
    },
  },
  methods: {
    switchStep(e, step) {
      if (e.target) {
        const clist = e.target.classList;
        if (clist.contains('el-step__title') && !clist.contains('is-wait')) {
          this.$emit('tapStep', step);
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.pt_tabs {
  min-width: 750px;
  .pt_tabs_basis {
    flex-basis: 25% !important;
  }
  .pt_tabs_basis_big {
    flex-basis: 31.5% !important;
  }
  .pt_current {
    ::v-deep .el-step__head .el-step__icon {
      background-color: #2775E8 !important;
      color: #fff !important;
    }
    ::v-deep .el-step__main .el-step__title {
      color: #2775E8 !important;
      opacity: 1 !important;
    }
  }
  ::v-deep .el-step .el-step__main .el-step__title  {
    font-size: 14px;
    white-space: nowrap;
    user-select: none;
    color: rgba($color: #000000, $alpha: 0.85);
    cursor: pointer;
    &.is-wait {
      cursor: default;
    }
  }
}
</style>